export const inactive = '#FFFFFF';
export const active = '#43ff43';
export const blocked = '#ffbb22';
export const cancelled = '#FF0000';
export const payable = '#4ccdff';
export const started = '#e87ae8';
export const completed = '#ff9595';